import { Button, Modal } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import seccessImage from "../../styles/images/success-tick-logo.svg";

const CommonModal = ({
  clickFunction,
  handleClose,
  show = false,
  message = "",
  ...props
}) => {
  return (
    <>
      <Modal
        className="forgotPasswordModal"
        show={show}
        onHide={handleClose}
        backdrop="static"
      >
        <Modal.Header
          closeButton
          style={{
            color: "#264AE4",
            // fontWeight: "600",
            fontSize: "18px",
            border: "none",
          }}
        >
        </Modal.Header>
        <Modal.Body>
          <div className="">
            <img src={seccessImage} alt="seccessImage" />
          </div>
          <div className="modalHeading">Success</div>
          <div className="modalText mt-2">{message || ""}</div>
        </Modal.Body>
        {/* <Modal.Footer className="loginModal">
          <Button
            variant="primary"
            onClick={() => clickFunction()}
          >
            Login
          </Button>
          <Button
            variant="outline-primary"
            // onClick={() => {
            //   closeTab();
            // }}
          >
            Cancel
          </Button>
        </Modal.Footer> */}
      </Modal>
    </>
  );
};

export default CommonModal;
